import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import {isJobActive} from './jobs';
import {createAxiosClient} from '../http-common';
const http = createAxiosClient();

const apiGetAllTasks = () => {
  return http.get('/task/all');
};

const apiCreateTask = (data) => {
  return http.post('/task', data);
};

const apiUpdateTask = (uid, data) => {
  return http.put(`/task/${uid}`, data);
};

const apiDeleteTask = (uid) => {
  return http.delete(`/task/${uid}`);
};

export const fetchTasks = createAsyncThunk(
    'tasks/FetchTasks',
    async () => {
      const result = await apiGetAllTasks();
      return result.data;
    }
);

export const addTask = createAsyncThunk(
    'tasks/add',
    async (task) => {
      const response = await apiCreateTask(task);
      return response.data;
    }
);

export const updateTask = createAsyncThunk(
    'tasks/update',
    async (task, thunkAPI) => {
      const response = await apiUpdateTask(task.uid, task);
      await thunkAPI.dispatch(fetchTasks());
      return response.data;
    }
);

export const removeTask = createAsyncThunk(
    'tasks/remove',
    async (task, thunkAPI) => {
      const response = await apiDeleteTask(task.uid);
      thunkAPI.dispatch(fetchTasks());
      return response.data;
    }
);

export const copyTask = createAsyncThunk(
    'tasks/copy',
    async (task) => {
      const response = await apiCreateTask(task);
      return response.data;
    }
);

const toNumberOrNull = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  return Number(value);
};

/* die API liefert beim Anlegen die geposteten Werte als String zurück */
export const normalizeTask = (task) => {
  if (!task) {
    return task;
  }

  return {
    ...task,
    uid: toNumberOrNull(task.uid),
    important: Number(task.important ?? 1),
    done: Number(task.done ?? 0),
    effort: parseFloat(task.effort ?? 0) || 0,
    job: toNumberOrNull(task.job),
    user: toNumberOrNull(task.user)
  };
};

const tasksSlice = createSlice({
  name: 'tasks',
  initialState: {
    items: [],
    status: 'idle',
    error: null
  },
  reducers: {

    move(state, action) {

      /* copy task */
      let task = {...action.payload.task};

      task.date = action.payload.date;

      if (action.payload.userId) {
        task.user = action.payload.userId;
      }

      if (action.payload.jobId) {
        task.job = action.payload.jobId;
      }

      /* replace task in state */
      const index = state.items.findIndex((item) => item.uid === task.uid);
      state.items[index] = task;

      apiUpdateTask(task.uid, task);
    }

//     update: (state, action) => {
//       const updatedTask = action.payload;
//       const index = state.items.findIndex(  (item) => item.uid === updatedTask.uid);
//       state.items[index] = updatedTask;
//
//       apiUpdateTask(updatedTask.uid, updatedTask);
//     },
  },
  extraReducers(builder) {
    builder
        .addCase(fetchTasks.pending, (state, action) => {
          state.status = 'loading';
        })
        .addCase(fetchTasks.fulfilled, (state, action) => {
          state.status = 'succeeded';
          state.items = Array.isArray(action.payload)
              ? action.payload.map(normalizeTask)
              : [];
        })
        .addCase(fetchTasks.rejected, (state, action) => {
          state.status = 'failed';
          state.error = action.error.message;
        })
        .addCase(addTask.fulfilled, (state, action) => {
          state.items.push(normalizeTask(action.payload));
        })
        .addCase(updateTask.fulfilled, (state, action) => {
        })
        .addCase(copyTask.fulfilled, (state, action) => {
          state.items.push(normalizeTask(action.payload));
//          fetchTasks();
        });
  }
});

export default tasksSlice.reducer;

// export const selectTaskByUid = (state, taskUid) => {
// //  console.log('state.tasks.items', state.tasks.items, taskUid, state.tasks.items.length);
//   return state.tasks.items.find((task) => task.uid === taskUid);
// }

export const selectTasks = (state) => {
  return state.tasks.items;
};

export const selectTaskByUid = (state, taskUid) => {
  if (!state.tasks.items) {
    return null;
  }

  return state.tasks.items.find((task) => task.uid === taskUid);
};

export const selectTasksByUserAndDate = (state, userId, date) => {
  return filterTasksByUserAndDate(state.tasks.items, userId, date);
};

export const filterTasksByUserAndDate = (tasks, userId, date) => {
//  console.log(tasks, userId, date);
  if (Array.isArray(tasks)) {
    return tasks.filter((task) => {
      if (!task.user || !task.date) {
        return false;
      }
      return task.user === userId && task.date === date;
    });
  }
  return [];
};

export const filterTasksByActiveJob = (tasks, jobs) => {
  if (!Array.isArray(tasks)) {
    return [];
  }

  return tasks.filter((task) => {
    /* Aufgaben ohne Job-Zuordnung bleiben sichtbar */
    if (!task.job) {
      return true;
    }

    const job = jobs?.find((item) => item.uid === task.job);

    /* Job noch nicht geladen? Dann nicht ausblenden */
    return job ? isJobActive(job) : true;
  });
};

export const countEffortByUserAndDate = (tasks, userId, date) => {
  let count = 0;
  for (const task of tasks) {
    if (task.user === userId && task.date === date) {
      count += parseFloat(task.effort);
    }
  }
  return count;
};

/* erst nach Typ (Home-Office, Schule, nicht buchbar, Urlaub, Notiz, Aufgabe),
   Aufgaben untereinander dann nach erledigt und Priorität */
export const sortTasksForCalendar = (tasks) => {
  if (Array.isArray(tasks)) {
    return tasks.sort((a, b) => {
      const sortOrderA = getTaskMode(a.mode).sortOrder;
      const sortOrderB = getTaskMode(b.mode).sortOrder;

      if (sortOrderA !== sortOrderB) {
        return sortOrderA - sortOrderB;
      }

      if (a.done === b.done) {
        return b.important - a.important;
      }
      return a.done - b.done;
    });
  }
  return [];
}

export const filterTasksByJobAndDate = (tasks, jobId, date) => {
  if (Array.isArray(tasks)) {
    return tasks.filter((task) => {
      if (!task.job || !task.date) {
        return false;
      }
      return task.job === jobId && task.date === date;
    });
  }
  return [];
}

/* effort === null -> der Benutzer stellt den Aufwand selbst ein
   sortOrder -> Reihenfolge der Karten im Kalender */
export const TASK_MODES = [
  {value: 'default',    label: 'Aufgabe',       effort: null, backgroundColor: undefined, bold: true,  sortOrder: 5},
  {value: 'note',       label: 'Notiz',         effort: 0,    backgroundColor: '#fff9db', bold: false, sortOrder: 4},
  {value: 'homeoffice', label: 'Home-Office',   effort: 0,    backgroundColor: '#dbedff', bold: false, sortOrder: 0},
  {value: 'school',     label: 'Schule',        effort: 8,    backgroundColor: '#dbedff', bold: false, sortOrder: 1},
  {value: 'blocked',    label: 'nicht buchbar', effort: 8,    backgroundColor: '#dbedff', bold: false, sortOrder: 2},
  {value: 'vacation',   label: 'Urlaub',        effort: 8,    backgroundColor: '#dbedff', bold: false, sortOrder: 3}
];

export const getTaskMode = (value) => {
  return TASK_MODES.find((mode) => mode.value === value) || TASK_MODES[0];
};

export const emptyTask = {
  teaser: '',
  description: '',
  effort: 0,
  important: 1,
  done: 0,
  mode: 'default',
  job: null,
  user: null
};
